export const MarkTrackingComplete = ({ form, formWatch, data, segment }) => {
	return (
		<div className='flex flex-col p-6 h-full w-full overflow-y-auto content-center bg-secondaryBackground'>
			<div className='text-black-300 font-medium test-sm'>Do you want to mark tracking as complete?</div>
		</div>
	)
}
